<template>
  <div>
    <toggle-switch
        :options="optionsList"
        @change="updateMap($event.value)"
        v-model="selectedMapOption"
        :value="selectedMapOption"
    />
  </div>
</template>

<script>
export default {
  name: "Switcher",
  props: {
    defaultValue: {
      type: String,
      default: 'DCP'
    }
  },
  data() {
    return {
      selectedMapOption: '',
      optionsList: {
        layout: {
          color: 'black',
          backgroundColor: '#fff',
          selectedColor: '#fff',
          selectedBackgroundColor: '#45AC34',
          borderColor: 'black',
          fontFamily: 'Fira Sans',
          fontWeight: 'normal',
          fontWeightSelected: '600',
          squareCorners: false,
          noBorder: false
        },
        size: {
          fontSize: 14,
          height: 37,
          padding: 9,
          width: 300,
          border: '1px solid red',
          backgroundColor: '#45AC34',
          selectedBackgroundColor: '#45AC34',
        },
        items: {
          delay: .4,
          preSelected: 'unknown',
          disabled: false,
          labels: [
            {name: 'DCP', color: '#fff', selectedBackgroundColor: '#45AC34;'},
            {name: 'MCP', color: '#fff', selectedBackgroundColor: '#45AC34;'},
            {name: 'TCP', color: '#fff', selectedBackgroundColor: '#45AC34;', disabled: true},
            {name: 'MDCP', color: '#fff', selectedBackgroundColor: '#45AC34;', disabled: true},
            {name: 'DFP', color: '#fff', selectedBackgroundColor: '#45AC34;', disabled: true},
          ]
        }
      }
    };
  },
  mounted() {
    this.selectedMapOption = this.defaultValue;
  },
  methods: {
    updateMap(val) {
      this.selectedMapOption = val;
    }
  },

  watch: {
    defaultValue() {
      this.selectedMapOption = this.defaultValue
    },

    selectedMapOption() {
      EventHub.$emit('selectedSwitcher', this.selectedMapOption);
    }
  }
}
</script>

<style>

.toggle-switch li label {
  font-family: Fira Sans, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border: 1px solid #D1D5DB !important;
}

.toggle-switch li:first-child label {
  border-radius: 100px 0 0 100px !important;
  border-left-width: 0;
}

.toggle-switch li:nth-child(2) label, .toggle-switch li:nth-child(3) label {
  border-left-width: 0 !important;
}

.toggle-switch li:last-child label {
  border-radius: 0 100px 100px 0 !important;
  border-left-width: 0 !important;
}
</style>
